import { render, staticRenderFns } from "./merge-route.vue?vue&type=template&id=743a5e4f&scoped=true&"
import script from "./merge-route.vue?vue&type=script&lang=js&"
export * from "./merge-route.vue?vue&type=script&lang=js&"
import style0 from "./merge-route.vue?vue&type=style&index=0&id=743a5e4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743a5e4f",
  null
  
)

export default component.exports